import { Turbo } from "@hotwired/turbo-rails"

// Custom Turbo Stream action: close a dialog
// Usage: turbo_stream.action(:close_dialog, "dialog_id")
Turbo.StreamActions.close_dialog = function() {
  const dialogId = this.target
  const dialog = document.getElementById(dialogId)
  if (dialog instanceof HTMLDialogElement) {
    dialog.close()
  }
}

// Custom Turbo Stream action: dispatch a record-created event for searchable selects
// Usage: turbo_stream.action(:select_record, "storage_key", record_id: "123", record_label: "Name")
Turbo.StreamActions.select_record = function() {
  const storageKey = this.target
  const recordId = this.getAttribute("record-id")
  const recordLabel = this.getAttribute("record-label")

  document.dispatchEvent(new CustomEvent("record-created", {
    detail: {
      storageKey: storageKey,
      value: recordId,
      label: recordLabel
    },
    bubbles: true
  }))
}

// Custom Turbo Stream action: reload a turbo frame
// Usage: turbo_stream.action(:reload_frame, "frame_id")
Turbo.StreamActions.reload_frame = function() {
  const frame = document.getElementById(this.target)
  if (frame?.reload) {
    frame.reload()
  }
}

